import store from "@/store";
import { VueConstructor } from "vue";

const icons = {
  dashboard: "mdi-view-dashboard-outline",

  // ============= MASTER DATA =============

  // GENERAL POSTING GROUP
  generalPostingGroup: "fas fa-mail-bulk",
  generalBusinessPostingGroup: "far fa-address-card",
  generalProductPostingGroup: "mdi-image-filter-none",
  inventoryPostingGroup: "fas fa-list-ol",
  bankAccountPostingGroup: "fas fa-university",
  clientPostingGroup: "fas fa-users",
  vendorPostingGroup: "fas fa-money-check",
  // GENERAL LEDGER
  chartOfAccount: "fas fa-file-invoice",
  chartOfAccountCategoryMenu: "fas fa-file-invoice",
  generalLedgerBudget: "fas fa-book",
  cashFlowBudget: "fas fa-book",
  dimension: "mdi-cube-outline",
  coaDimensionMatrix: "mdi-table-large",
  generalBudgetJournal: "mdi-book-plus-outline",
  generalBudgetEntry: "mdi-book-check-outline",
  // TAX SUBMISSION
  selfBilledInvoice: "fas fa-file-invoice",
  taxIntegrationLog: "fas fa-file-invoice",
  // GENERAL CONFIGURATION
  generalConfiguration: "fas fa-cogs",
  accountingPeriod: "fas fa-calendar-week",
  inventoryPeriod: "fas fa-calendar-day",
  paymentTerm: "fas fa-money-bill-wave",
  unitOfMeasurement: "fas fa-ruler",
  warehouseLocation: "fas fa-warehouse",
  bankAccount: "mdi-bank",
  numberSeries: "fas fa-sort-numeric-up-alt",
  purchaseRequisitionBatch: "fas fa-cash-register",
  generalJournalBatch: "fas fa-book-open",
  itemJournalBatch: "fas fa-book-open",
  reportSetting: "mdi-google-spreadsheet",
  interDepartmentTransferBatch: "fas fa-book-open",
  // POSTING SETUP
  postingSetup: "fas fa-toolbox",
  generalPostingSetup: "fas fa-wrench",
  inventoryPostingSetup: "fas fa-screwdriver",
  userPostingSetup: "fas fa-hammer",
  inventoryReconciliationSetup: "fas fa-book",
  // VAT POSTING GROUP
  vatPostingGroup: "fas fa-object-group",
  vatProductPostingGroup: "fas fa-box-open",
  vatBusinessPostingGroup: "fas fa-briefcase",
  vatPostingSetup: "fas fa-boxes",

  // ============= DOCUMENT FLOW =============

  masterDocumentFlow: "fas fa-file-import",
  documentFlowSequenceType: "fas fa-file-medical-alt",
  documentAttachment: "mdi-attachment",

  // ============= GENERAL LEDGER =============

  generalLedger: "fas fa-clipboard",
  generalJournal: "fas fa-book",
  client: "fas fa-user-tie",
  vendor: "fas fa-dolly-flatbed",
  purchasePayableSetup: "fas fa-file-invoice-dollar",
  salesReceivableSetup: "fas fa-receipt",
  generalLedgerSetup: "fas fa-cog",
  accountReconciliationJournal: "fas fa-book",
  closeIncomeStatement: "fas fa-door-closed",
  generalJournalMasterTemplate: "fas fa-clipboard",
  generalLedgerEntryChangesLogs: "mdi-book-open-page-variant",

  // ============= RECEIVABLE =================
  cashReceiptJournal: "fas fa-receipt",
  salesInvoice: "fas fa-receipt",
  salesCreditMemo: "fas fa-receipt",
  receivableInvoice: "fas fa-receipt",
  invoiceEmailLog: "fas fa-envelope-open-text",

  // ============= INVENTORY ==============
  item: "fas fa-cheese",
  itemVendorPurchaseprice: "fas fa-cheese",
  inventorySetup: "fas fa-truck-loading",
  itemJournal: "fas fa-book",
  itemLedgerEntry: "fas fa-book",
  physicalInventoryJournal: "fas fa-book",
  itemJournalMasterTemplate: "fas fa-book",
  interDepartmentTransfer: "fas fa-exchange-alt",
  interDepartmentTransferDetail: "fas fa-list",
  // ============= PURCHASING =============

  purchaseRequest: "fas fa-file-alt",
  outstandingPurchaseRequest: "fas fa-file-alt",
  purchaseOrder: "fas fa-file-alt",
  purchaseReceiving: "fas fa-file-alt",
  purchaseInvoice: "fas fa-file-alt",
  purchaseRequisitionTemplate: "fas fa-list",
  reports: "mdi-google-spreadsheet",
  storeRequisitionList: "fas fa-list",
  storeRequisitionDetail: "fas fa-list",
  storeRequisition: "fas fa-list",
  storeRequisitionBatch: "fas fa-list",
  storeRequisitionTemplate: "fas fa-list",
  outstandingStoreRequisition: "fas fa-list",
  paymentJournal: "fas fa-book",
  purchaseCreditMemo: "fas fa-book",

  purchaseOrderDetail: "fas fa-file-alt",
  purchaseReceiptDetail: "fas fa-file-alt",
  purchaseRequestDetail: "fas fa-file-alt",
  purchaseInvoiceDetail: "fas fa-file-alt",
  
  processExpired: "mdi-file-cog-outline",
  revertExpired: "mdi-file-refresh-outline",
  // ============= ENTRY ===============
  valueEntry: "fas fa-book",
  generalLedgerEntry: "fas fa-book",
  vatEntry: "fas fa-book",
  itemApplicationEntry: "fas fa-book",
  averageCostCalculationEntry: "fas fa-book",
  vendorLedgerEntry: "fas fa-book",
  vendorLedgerEntryDetail: "fas fa-book",
  clientLedgerEntry: "fas fa-book",
  clientLedgerEntryDetail: "fas fa-book",
  physicalInventoryLedgerEntry: "fas fa-book",
  bankAccountLedgerEntry: "fas fa-book",
  bankAccountLedgerEntryDetail: "fas fa-book",
  generalJournalEntry: "fas fa-book",
  itemJournalLog: "fas fa-book",
  // ADJUSTMENT TOOLS
  adjustmentTools: "fas fa-cogs",
  adjustSingleEntry: "fas fa-wrench",
  adjustSOH: "fas fa-wrench",
  adjustCostItemEntries: "fas fa-wrench",
  revaluationJournalAllItems: "fas fa-wrench",

  // ============= POSTED ===============
  postedPurchaseReceipt: "fas fa-book",
  postedPurchaseInvoice: "fas fa-book",
  postedPurchaseCreditMemo: "fas fa-book",
  postedStoreRequisition: "fas fa-book",
  postedSalesInvoice: "fas fa-book",
  postedSalesCreditMemo: "fas fa-book",

  // ============= CUSTOM ICONS ===============
  eyeIcon: "mdi-eye-outline",
  rejectIcon: "mdi-cancel",
  purchaseReceiveCanceled: "fas fa-ban",

  // ============= APPROVAL ===============
  documentApproval: "fas fa-check-square",

  // ============= REPORT ===============
  balanceSheet: "mdi-google-spreadsheet",
  balanceSheetYTDSummary: "mdi-google-spreadsheet",
  trialBalance: "mdi-google-spreadsheet",
  arAgingDiscrepancy: "mdi-google-spreadsheet",
  apAgingDiscrepancy: "mdi-google-spreadsheet",
  bankAccountAgingDiscrepancy: "mdi-google-spreadsheet",
  profitAndLoss: "mdi-google-spreadsheet",
  profitAndLossCurrentMonthConsolidation: "mdi-google-spreadsheet",
  profitAndLossYTDConsolidation: "mdi-google-spreadsheet",
  profitAndLossYTDSummary: "mdi-google-spreadsheet",
  cashFlow: "mdi-cash-multiple",
  cashFlowYTDSummary: "mdi-cash-multiple",
  cashFlowByDepartment: "mdi-cash-multiple",
  accountPayableAging: "mdi-google-spreadsheet",
  accountPayableInterim: "mdi-google-spreadsheet",
  accountPayableInterimAging: "mdi-google-spreadsheet",
  accountPayablePaymentList: "mdi-google-spreadsheet",
  accountReceivableAging: "mdi-google-spreadsheet",
  accountReceivableAgingCard: "mdi-google-spreadsheet",
  arAgingCardAndLedger: "mdi-google-spreadsheet",
  accountReceivablePaymentList: "mdi-google-spreadsheet",
  accountReceivablePaymentListCard: "mdi-google-spreadsheet",
  accountReceivablePaymentListLedger: "mdi-google-spreadsheet",
  inventoryAccountBalanceDetail: "mdi-google-spreadsheet",
  slowMovingInventory: "mdi-google-spreadsheet",
  stockOnHand: "mdi-google-spreadsheet",
  topPurchaseItem: "mdi-google-spreadsheet",
  dailyFlashCost: "mdi-google-spreadsheet",
  itemExpense: "mdi-google-spreadsheet",
  receivingReport: "mdi-google-spreadsheet",
  inventoryReconciliation: "mdi-google-spreadsheet",
  itemReorder: "mdi-google-spreadsheet",
  topPurchaseByVendor: "mdi-google-spreadsheet",
  outstandingPurchaseOrder: "mdi-google-spreadsheet",
  inventoryMovementReport: "mdi-google-spreadsheet",
  accountScheduleConsolidation: "mdi-google-spreadsheet",
  itemConsumptionReport: "mdi-google-spreadsheet",

  // ============= REPORT ===============
  changesLogs: "mdi-book-open-page-variant",
  cancelledPurchaseReceipts: "mdi-book-open-page-variant",
  approvalDocumentWithdrawal: "mdi-book-open-page-variant",
  printoutLayout: "fas fa-print",
};

declare module "vue/types/vue" {
  interface Vue {
    $i: (args: any) => string;
  }
}

const iconSet = (id: any) => {
  return icons[id];
};

export const iconPlugin = {
  install(Vue: VueConstructor) {
    Vue.prototype.$i = iconSet;
  }
};

export const useIconSet =  () => {
  return {
    iconSet,
  };
};
